// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from '@node-space/ui-components'
import { updateBeneficiaryAsMigrated } from 'services/BeneficiaryService'
import { BaseErrorResponse, BeneficiaryDetails } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useContactMigrationBeneficiaryUpdate = () => {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({
      beneficiary,
      instrumentId,
    }: {
      beneficiary: BeneficiaryDetails
      instrumentId: string
    }) => updateBeneficiaryAsMigrated(beneficiary, instrumentId),
    onSuccess: () => {
      toast({
        header: t('manageBeneficiaries.beneficiaryUpdatedSuccessfully'),
        variant: 'success',
      })
    },
    onError: (error: BaseErrorResponse) => {
      toast({
        header: t('manageBeneficiaries.errorUpdatingBeneficiary'),
        variant: 'error',
        body: t('manageBeneficiaries.errorUpdatingBeneficiaryDescription'),
      })
      logSentryError('Error: useContactMigrationBeneficiaryUpdate', error)
    },
  })
}
